import { COLOR, histogram } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'BOP',
  version: 1,
  label: 'Balance of Power',
  pane: 'sub',
  category: 'momentum',
  series: 'normal',
  precision: 4,
  order: 160,
  inputs: [],
  outputs: [histogram('bop', 'BOP', COLOR.green, COLOR.red)],
  talib: { functions: ['BOP'], expr: 'BOP(open, high, low, close)' },
  listed: true,
  tailSafe: true,
  lookback: () => 0,
}
export default def
